import { Link } from "@fluentui/react-components";
import { Open16Filled } from "@fluentui/react-icons";

import './IconLink.scss'

export interface IIconLinkProps {
    href: string,
    text: string,
    testid?: string,
}

export default function IconLink({ href, text, testid }: IIconLinkProps) {

    return (
        <Link className="icon-link"
            href={href}
            title={href}
            data-testid={testid}
            target="_blank"
            rel="noopener noreferrer">
            {text}
            {" "}
            <Open16Filled />
        </Link>
    );
};
